import { Link } from "react-router-dom";
import { useSite } from "@/components/site/SiteLayout";
import useSeo from "@/hooks/useSeo";
import { IconWifi, IconBolt } from "@/components/site/icons";

export default function Servizi() {
  const c = useSite();
  useSeo("I Nostri Servizi", "Servizi POWERCOM: reti in fibra ottica e rame, impianti elettrici, videosorveglianza, allarmi, antincendio, idrico-sanitari, climatizzazione e trattamento aria.");
  const cats = c.service_categories || [];
  return (
    <>
      <section className="page-hero">
        <div className="container reveal">
          <span className="eyebrow light">I Nostri Servizi</span>
          <h1>Soluzioni complete per reti e impianti tecnologici.</h1>
          <p>Dalla fibra ottica agli impianti di sicurezza e climatizzazione: un unico partner per ogni esigenza.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {cats.map((cat, i) => (
            <div className="svc-cat reveal" key={i} data-testid={`svc-cat-${i}`}>
              <div className="svc-cat-head">
                <div className="ico">{i === 0 ? <IconWifi /> : <IconBolt />}</div>
                <div><h2>{cat.name}</h2><span>{cat.subtitle}</span></div>
              </div>
              <div className="svc-list">
                {(cat.items || []).map((it, j) => (
                  <div className="svc-item" key={j}>
                    <h4>{it.title}</h4>
                    <p>{it.desc}</p>
                  </div>
                ))}
              </div>
              {cat.gallery && cat.gallery.length > 0 && (
                <div className="svc-gallery" data-testid={`svc-gallery-${i}`}>
                  {cat.gallery.map((src, k) => (
                    <div className="svc-photo" key={k}>
                      <img src={src} alt={`${cat.name} — foto ${k + 1}`} loading="lazy" />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <section className="section section-soft">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow">Come lavoriamo</span>
            <h2>Un metodo chiaro in 4 fasi.</h2>
          </div>
          <div className="steps">
            <div className="step reveal"><strong>1</strong><h4>Sopralluogo</h4><p>Analisi delle esigenze e del contesto.</p></div>
            <div className="step reveal"><strong>2</strong><h4>Progettazione</h4><p>Soluzione tecnica su misura.</p></div>
            <div className="step reveal"><strong>3</strong><h4>Realizzazione</h4><p>Installazione a regola d'arte.</p></div>
            <div className="step reveal"><strong>4</strong><h4>Manutenzione</h4><p>Assistenza e supporto nel tempo.</p></div>
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="container cta-inner reveal">
          <h2>Serve un preventivo?</h2>
          <p>Raccontaci il tuo progetto: ti forniremo una soluzione dedicata.</p>
          <Link to="/contatti" className="btn btn-light">Richiedi un preventivo</Link>
        </div>
      </section>
    </>
  );
}
